<div id="navContainer" class="v2" [class.v2-mobile]="isMobile">
  @if (isFinnet()) {
    <div class="finnet-title-row">
      <h2>AI Analyse</h2>
      <button class="modal" (click)="onInfoClick()">
        <img [src]="iconPath" alt="Info" />
      </button>
    </div>
  } @else {
    <div class="titleArrow">
      <div class="navTitleWrapper">
        <div class="titleAndPrice">
          @if (name !== '' && isin) {
            <h2>{{ name | smartTitleCase }}</h2>
          }
          @if (price) {
            <p class="price">
              {{ price | priceScale }}
            </p>
          }
          @if (price && prevPrice) {
            <p
              class="percentage"
              [ngClass]="{ positive: price > prevPrice, negative: price < prevPrice }"
            >
              {{ price | percentageChange: prevPrice }}
            </p>
          }
        </div>

        @if (isMobile) {
          <div class="v2-price-row">
            @if (price) {
              <p class="price">
                {{ price | priceScale }}
              </p>
            }
            @if (price && prevPrice) {
              <p
                class="percentage"
                [ngClass]="{ positive: price > prevPrice, negative: price < prevPrice }"
              >
                {{ price | percentageChange: prevPrice }}
              </p>
            }
          </div>
        }

        @if (isin && !analyseType && showCompanyLink) {
          <app-arrow-button
            label="Unternehmensprofil"
            (clicked)="onCompanyClick()"
          ></app-arrow-button>
        }
      </div>
    </div>
    <nav id="modalButton">
      <button class="modal" (click)="onInfoClick()">
        <img class="modalImg v2" [src]="iconPath" alt="Info" />
      </button>
    </nav>
  }
</div>

<app-info-modal
  #modal
  [title]="'Hinweis'"
  [actionLabel]="'Verstanden'"
  (action)="onInfoClose()"
  (closed)="onInfoClose()"
></app-info-modal>
